import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { useStyles, StyledTableCell } from './userReportsStyles';
import { DB_DATE_FORMAT, DISPLAY_DATE_FORMAT } from '../../../redux/constants';
import { convertToDateString } from '../../../redux/utils/customMethods';
import { getStartEndDatesByMonthYear, getWeekDays } from './yearData';
import ExportToExcelButton from './exportExcel/ExportExcel';
import {
  fetchAllTimesheets,
  fetchTimesheet,
} from '../../../redux/timesheets/timesheetsActions';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Grid,
  Button,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  TableContainer,
  Typography,
} from '@material-ui/core';

const UserReports = () => {
  document.title = 'Sciata Reports';

  const dispatch = useDispatch();
  const classes = useStyles();

  const [open, setOpen] = useState(false);
  const [view, setView] = useState('month');
  const [year, setYear] = useState(moment().get('year'));
  const [weeksForYears, setWeekForYears] = useState([]);

  const months = () => {
    let _months = [];
    let _cMonth = moment().format('MM');
    if (year < moment().year()) {
      _cMonth = '12';
    }
    let _dateNow = moment(`${_cMonth}/${moment().format('DD')}/${year}`, 'MM/DD/YYYY');
    for (let i = _dateNow.month(); i >= 0; i -= 1) {
      let d = moment(`${_dateNow.year()}-${_dateNow.month() + 1 - i}-${1}`);
      _months.push(d.format('MMMM'));
    }
    return _months;
  };
  const [modalObject, setModalObject] = useState({});
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [viewNote, setViewNote] = useState(false);

  const user = useSelector(state => state.users.currentUser);
  const timesheet = useSelector(state => state.timesheets.currentTimesheet);
  const timesheets = useSelector(state => state.timesheets.all);

  let weekRows = [];
  let monthRows = [];

  const dayColumns = [
    { id: 'date', label: 'Date' },
    { id: 'hour', label: 'Hours' },
    { id: 'projectId', label: 'Project' },
    { id: 'note', label: 'Note' },
  ];

  const weekColumns = [
    { id: 'week', label: 'Week' },
    { id: 'totalHrs', label: 'Total Hours' },
    { id: 'notes', label: 'Notes' },
  ];

  const monthColumns = [
    { id: 'month', label: 'Month' },
    { id: 'totalHours', label: 'Total Hours' },
    { id: 'notes', label: 'Notes' },
  ];

  monthRows = (() => {
    return !months()
      ? null
      : (monthRows = months().map(month => {
          let arrayOfObjects = [];
          let daysForMonthView = [];
          let monthlyTotalHours = '';
          const monthStartEndDates = getStartEndDatesByMonthYear(
            moment().month(month).format('M'),
            year
          );
          if (timesheets && timesheets.users && timesheets.users[0].weekly[0]) {
            timesheets.users[0].weekly.map(ts => {
              if (
                ts.fromDate.split('-')[0] === monthStartEndDates.startDate.split('-')[0]
              ) {
                arrayOfObjects.push(ts);
                daysForMonthView.push(...ts.days);
              }
            });
          }
          monthlyTotalHours = arrayOfObjects.length
            ? arrayOfObjects.reduce((accum, current) => {
                return accum + Number(current.total_hours);
              }, 0)
            : 0;

          return {
            month: month,
            totalHours: monthlyTotalHours,
            startDate: monthStartEndDates.startDate,
            endDate: monthStartEndDates.endDate,
            days: daysForMonthView,
          };
        }));
  })();

  weekRows = (() => {
    return !weeksForYears
      ? null
      : (weekRows = weeksForYears.map(week => {
          let weekStartDate = `${week.startDate}`;
          let weekEndDate = `${week.endDate}`;
          let daysForWeeksView = [];

          timesheets.users &&
            timesheets.users[0].weekly.map(ts => {
              if (weekStartDate === ts.fromDate) {
                daysForWeeksView.push(...ts.days);
              }
            });

          let populatedObject =
            timesheets.users && timesheets.users[0]
              ? timesheets.users[0].weekly.find(object => {
                  return object.fromDate === weekStartDate;
                })
              : null;

          return {
            week: `${weekStartDate} - ${weekEndDate}`,
            days: daysForWeeksView,
            totalHrs:
              populatedObject && Object.keys(populatedObject).length
                ? populatedObject.total_hours
                : 0,
          };
        }));
  })();

  useEffect(() => {
    document.title = 'Sciata Reports';
    setViewNote(!viewNote);
  }, [view]);

  const handleClose = () => setOpen(false);
  const handleViewToggle = e => setView(e.target.value);

  const handleClickOpen = row => {
    setOpen(true);
    if (view === 'week') {
      setStartDate(`${row.week.split(' ')[0]}`);
      setEndDate(`${row.week.split(' ')[2]}`);
      return;
    }

    setStartDate(`${row.startDate}-${year}`);
    setEndDate(`${row.endDate}-${year}`);
    setModalObject(row);
    return;
  };

  useEffect(() => {
    if (user.id) {
      dispatch(
        fetchAllTimesheets({
          role: user.role,
          userId: user.id,
          projectCode: '4000',
          year: year,
        })
      );
    }
    setWeekForYears(getWeekDays(year));
  }, [view, year]);

  useEffect(() => {
    view === 'week' &&
      (startDate || '') !== '' &&
      (endDate || '') !== '' &&
      dispatch(
        fetchTimesheet({
          fromDate: startDate,
          toDate: endDate,
          role: user.role,
          userId: user.id,
          projectCode: '4000',
          year: '',
        })
      );

    view === 'month' &&
      (startDate || '') !== '' &&
      (endDate || '') !== '' &&
      dispatch(
        fetchTimesheet({
          fromDate: startDate,
          toDate: endDate,
          role: user.role,
          userId: user.id,
          projectCode: '4000',
          year: '',
        })
      );
  }, [view, startDate, endDate]);

  const renderTableHeader = () => {
    const headerColumns = view === 'month' ? monthColumns : weekColumns;

    return headerColumns.map(column => (
      <TableCell className={classes.tableHead} key={column.id} align='center'>
        {column.label}
      </TableCell>
    ));
  };

  const renderModalTableHeader = () => {
    const headerColumns = dayColumns;

    return headerColumns.map(column => (
      <StyledTableCell className={classes.tableHead} key={column.id} align='center'>
        {column.label}
      </StyledTableCell>
    ));
  };

  const renderModalTableBody = () => {
    const projectsObj = {};
    user.projects.forEach(project => {
      projectsObj[project.code] = project.name;
    });
    if (view === 'week' && timesheet.weekly && timesheet.weekly[0]) {
      return timesheet.weekly[0].days.map(row => {
        return (
          <TableRow hover role='checkbox' tabIndex={-1} key={row.code}>
            {dayColumns.map(column => {
              const value =
                column.id === 'date'
                  ? convertToDateString(row[column.id], DB_DATE_FORMAT)
                  : row[column.id];
              return (
                <TableCell key={column.id} align='center'>
                  {column.id === 'projectId'
                    ? projectsObj[row.projectId] || row.task
                    : column.id !== 'notes'
                    ? value
                    : null}
                </TableCell>
              );
            })}
          </TableRow>
        );
      });
    }

    if (
      view === 'month' &&
      monthRows &&
      monthRows.length &&
      modalObject.days &&
      user.projects
    ) {
      return modalObject.days.map(day => {
        const projectsObj = {};
        user.projects.forEach(project => {
          projectsObj[project.code] = project.name;
        });

        return Object.keys(day).length ? (
          <TableRow hover role='checkbox' tabIndex={-1} key={day.id}>
            <TableCell align='center'>
              {convertToDateString(day.date, DB_DATE_FORMAT)}
            </TableCell>

            <TableCell align='center'>{day.hour}</TableCell>
            <TableCell align='center'>{projectsObj[day.projectId] || day.task}</TableCell>
            <TableCell align='center'>{day.note}</TableCell>
          </TableRow>
        ) : (
          <div>No Data</div>
        );
      });
    }
  };

  const buildExportNoteObject = () => {
    const projectsObj = {};
    user.projects.forEach(project => {
      projectsObj[project.code] = project.name;
    });
    let exportData = [];
    if (view === 'week' && timesheet.weekly && timesheet.weekly[0]) {
      timesheet.weekly[0].days.map(row => {
        row['projectCode'] = row.projectId ? projectsObj[row.projectId] : row.task;
        row['date'] = convertToDateString(row['date'], DB_DATE_FORMAT);
        exportData.push(row);
      });
    }
    if (
      view === 'month' &&
      monthRows &&
      monthRows.length &&
      modalObject.days &&
      user.projects
    ) {
      modalObject.days.map(day => {
        const projectsObj = {};
        user.projects.forEach(project => {
          projectsObj[project.code] = project.name;
        });
        day['projectCode'] = day.projectId ? projectsObj[day.projectId] : day.task;
        day['date'] = convertToDateString(day['date'], DB_DATE_FORMAT);
        exportData.push(day);
      });
    }
    return exportData;
  };

  const renderTableBodyRows = () => {
    const bodyRows =
      view === 'month' ? (monthRows || []).reverse() : (weekRows || []).reverse();
    const columns = view === 'month' ? monthColumns : weekColumns;

    return !bodyRows ? (
      <h1>No Data</h1>
    ) : (
      bodyRows.map(row => {
        const notes = row.days && row.days.filter(day => day.note !== '');

        return (
          <TableRow hover role='checkbox' tabIndex={-1} key={row.code}>
            {columns.map(column => {
              let value = '';
              if (column.id === 'week') {
                let dates = row[column.id].split(' ');
                value =
                  convertToDateString(dates[0], DB_DATE_FORMAT) +
                  ' - ' +
                  convertToDateString(dates[2], DB_DATE_FORMAT);
              } else {
                value = row[column.id];
              }
              return (
                <TableCell key={column.id} align='center'>
                  {column.id !== 'notes' ? (
                    value
                  ) : (
                    <Button
                      className={classes.positiveBtn}
                      variant='contained'
                      disabled={notes !== undefined && notes.length === 0}
                      onClick={() => handleClickOpen(row)}
                    >
                      View Notes
                    </Button>
                  )}
                </TableCell>
              );
            })}
          </TableRow>
        );
      })
    );
  };

  return (
    <>
      <h1>Reports</h1>
      <Grid container justify='center' alignItems='center'>
        <Grid item xs={12} container justify='center'>
          <Button onClick={() => setYear(year - 1)}>
            <ArrowBackIosIcon className={classes.arrowIcons} />
          </Button>
          <h2 className={classes.weekSelectorContent}>{year}</h2>
          <Button
            onClick={() =>
              year < moment().get('year') ? setYear(year + 1) : setYear(year)
            }
          >
            <ArrowForwardIosIcon className={classes.arrowIcons} />
          </Button>
        </Grid>
        <FormControl component='fieldset'>
          <RadioGroup
            aria-label='timeFrame'
            name='timeFrame'
            value={view}
            onChange={handleViewToggle}
            row
          >
            <FormControlLabel
              value='week'
              control={<Radio color='primary' />}
              label='Week'
            />
            <FormControlLabel
              value='month'
              control={<Radio color='primary' />}
              label='Month'
            />
          </RadioGroup>
        </FormControl>

        <Grid container>
          <Grid item xs={12}>
            <Paper className={classes.tableRoot}>
              <TableContainer className={classes.tableContainer}>
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>{renderTableHeader()}</TableRow>
                  </TableHead>
                  <TableBody>{renderTableBodyRows()}</TableBody>
                </Table>
              </TableContainer>
            </Paper>
          </Grid>
        </Grid>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby='form-dialog-title'
          fullWidth={true}
          maxWidth={'md'}
        >
          <DialogTitle id='form-dialog-title' className={classes.dialogTitleContainer}>
            <Grid container justify='space-between' alignItems='center'>
              <Grid item xs={6}>
                <Typography variant='h5' className={classes.dialogTitle}>
                  {`${convertToDateString(
                    startDate,
                    DB_DATE_FORMAT
                  )} - ${convertToDateString(endDate, DB_DATE_FORMAT)}`}
                </Typography>
              </Grid>
              <Grid item xs={6} container justify='flex-end'>
                <ExportToExcelButton data={buildExportNoteObject() || []} />
              </Grid>
            </Grid>
          </DialogTitle>
          <DialogContent style={{ padding: 0 }}>
            <Paper className={classes.modalTableRoot}>
              <TableContainer className={classes.modalTableContainer}>
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>{renderModalTableHeader()}</TableRow>
                  </TableHead>
                  <TableBody alignItems='center'>{renderModalTableBody()}</TableBody>
                </Table>
              </TableContainer>
            </Paper>
          </DialogContent>
          <Divider />
          <DialogActions>
            <Button onClick={handleClose} className={classes.negativeBtn}>
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </Grid>
    </>
  );
};

export default UserReports;
